import { PrettyPrintJson } from './PrettyPrintJson';
import { jsx as _jsx } from "react/jsx-runtime";
export function DisplayOnlyBlock({
  block
}) {
  const {
    text
  } = block;
  if (text === undefined) return null;
  return /*#__PURE__*/_jsx(PrettyPrintJson, {
    data: text,
    defaultOpen: true
  });
}
DisplayOnlyBlock.canRender = block => {
  const {
    text
  } = block;
  return text !== undefined;
};